import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { forkJoin } from 'rxjs';
import { BookingWithUsers } from '../booking-with-users';
import { HttpService } from '../service/http.service';
import { Language } from '../language';
import { BookingService } from '../service/booking.service';
import { BookingsSearchService } from '../service/bookings-search.service';
import { SimpleSchool } from '../simple-school';
import { SimpleUser } from '../simple-user';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-bookings-with-users',
  templateUrl: './bookings-with-users.component.html',
  styleUrls: ['./bookings-with-users.component.css']
})
export class BookingsWithUsersComponent implements OnInit {

  bookings: BookingWithUsers[] = [];
  users: SimpleUser[] = [];
  languages: Language[] = [];
  schools: SimpleSchool[] = [];
  isLoading = false;

  @ViewChild('dataTable') table!: Table;

  constructor(
    private httpService: HttpService,
    public bookingService: BookingService,
    public bookingSearchService: BookingsSearchService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.isLoading = true;
    forkJoin({
      bookings: this.httpService.getAllBookingsWithUsers(),
      users: this.httpService.getAllSimpleUsers(),
      languages: this.httpService.getLanguages(),
      schools: this.httpService.getSimpleSchools()
    }).subscribe(({
      bookings,
      users,
      languages,
      schools
    }) => {
      this.bookings = bookings;
      this.users = users;
      this.languages = languages;
      this.schools = schools;
      for (let booking of this.bookings) {
        for (let user of booking.users) {
          if (!booking.userNames) {
            booking.userNames = user.name;
          } else {
            booking.userNames = booking.userNames + ", " + user.name;
          }
        }
      }
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
    });
  }

  onDateSelect(value: Date, colName: string) {
    this.table.filter(moment(value).format("YYYY-MM-DD"), colName, 'equals');
  }

  openBooking(booking: BookingWithUsers) {
    let url = this.router.serializeUrl(
      this.router.createUrlTree(["/management/edit-booking/" + booking.lvcId])
    );
    window.open(url, "_blank");
  }
}
